import { render, staticRenderFns } from "./PartnerList.vue?vue&type=template&id=078c741e&scoped=true"
import script from "./PartnerList.vue?vue&type=script&lang=js"
export * from "./PartnerList.vue?vue&type=script&lang=js"
import style0 from "./PartnerList.vue?vue&type=style&index=0&id=078c741e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078c741e",
  null
  
)

export default component.exports